import { useEffect, useState } from 'react';
import useWebshopWidgetDictionary from './useWebshopWidgetDictionary';
import useWebshopWidgets from './useWebshopWidgets';

type WidgetData = {
  widgetType: string;
  data: string;
  component: ({ data }: { data: string }) => JSX.Element;
};

const useWidgetComponents = () => {
  const { webshopWidgets } = useWebshopWidgets();
  const { getWebshopWidgetsByType } = useWebshopWidgetDictionary();
  const [widgetData, setWidgetData] = useState<WidgetData[]>([]);

  useEffect(() => {
    webshopWidgets?.forEach((widget) => {
      const Component = getWebshopWidgetsByType(widget.widgetType);

      if (Component) {
        const data: WidgetData = {
          widgetType: widget.widgetType,
          data: widget.data,
          component: Component
        };
        setWidgetData((prevData) => [...prevData, data]);
      }
    });
  }, [webshopWidgets]);

  return { widgetData };
};

export default useWidgetComponents;
